<template>
    <el-dialog :title="$t('component.PayTokenDialog_title')" :visible.sync="charDialog.show" destroy-on-close @open="openCharDialogEvent" @close="closeCharDialogEvent" width="872px" top="20px" v-if="charDialog">
        <div class="pay-pro-success" v-if="status === 'paid'">
            <i class="el-icon-success"></i>
            <div class="fonts-20 margin-t-10">{{$t('component.PayTokenDialog_tips_1')}}</div>
            <div class="fonts-14 margin-t-10">{{$t('component.PayTokenDialog_tips_2')}}</div>
            <img src="../../static/images/tencent-group-qrcode.jpg" alt="qrcode"/>
            <div class="fonts-14 margin-t-10">{{$t('component.PayTokenDialog_tips_3')}}</div>
        </div>
        <div class="pay-char-dialog" v-loading="loading" v-else>
            <div class="pay-type-content">
                <template v-for="(token, index) in list">
                    <div :key="index" class="item" :class="{active: charDialog.type === token.code}" @click="changePayTypeEvent(token.code)">
                        <div class="text-weight-600 fonts-18">{{token.desc}}</div>
                        <div class="text-weight-700 fonts-30 margin-t-10">￥{{token.price}}<!-- <span class="line-through margin-l-10 fonts-16 color-919191">￥19</span> --></div>
                    </div>
                </template>
            </div>
            <div class="pay-detail-content">
                <template v-if="order">
                    <div class="qrcode">
                        <img class="width-full" :src="order.codeImgUrl" alt="qrcode"/>
                    </div>
                    <div class="fonts-12" style="padding-left:30px;">
                        <div>{{$t('component.PayTokenDialog_tips_7')}}<span class="margin-l-10">{{order.orderNo}}</span></div>
                        <div class="margin-t-15">{{$t('component.PayTokenDialog_tips_8')}}<span class="margin-l-10 fonts-24">{{$t('component.PayTokenDialog_tips_6', {price: order.amount})}}</span></div>
                        <div class="margin-t-15 flex flex-align-center">
                            {{$t('component.PayTokenDialog_tips_9')}}
                            <svg-icon name="ic-wechat-pay" className="margin-l-10" style="width: 22px;height: 22px;"></svg-icon>
                            <span class="margin-l-5">{{$t('component.PayTokenDialog_tips_4')}}</span>
                        </div>
                    </div>
                </template>
            </div>
            <div class="fonts-12 margin-t-25 text-center">{{$t('component.PayTokenDialog_tips_10')}} <a href="http://static.languagex.com/page/serviceTerms.html" target="_blank">{{$t('component.PayTokenDialog_tips_11')}}</a> {{$t('component.PayTokenDialog_tips_12')}} <a href="http://static.languagex.com/page/privacyPolicy.html" target="_blank">{{$t('component.PayTokenDialog_tips_13')}}</a></div>
        </div>
    </el-dialog>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { userApi, payApi } from '@/utils/api';
export default {
    name: 'PayTokenDialog',
    data(){
        return{
            order: null,
            loading: false,
            orderStatusTimer: null,
            status: '',
            list: [],
        }
    },

    computed: {
        ...mapState({
            charDialog: state=>state.pay.payTokenDialog,
        })
    },

    methods: {
        initList() {
            let url = `${payApi.queryPriceOptions}?type=TOKEN`;
            this.$ajax.get(url).then(res=>{
                if(res.status === 200){
                    this.list = res.data;
                    this.initOrder();
                }
            });
        },
        closeCharDialogEvent(){
            this.status = '';
            this.$store.dispatch('pay/setPayTokenDialog',{show: false});
            clearInterval(this.orderStatusTimer);
            this.orderStatusTimer = null;
            this.$router.replace('/account/agentToken');
            setTimeout(()=>{
                location.reload(true);
            }, 800);
        },
        openCharDialogEvent(){
            this.initList();
        },
        initOrder(){
            let self = this;
            let url = `${payApi.createOrder}`;
            this.loading = true;
            this.$ajax.post(url,{
                method: 'token',
                packCode: this.charDialog.type,
                channel: 'wechat',
            }).then(res=>{
                if(res.status === 200){
                    this.order = res.data;
                    if(this.orderStatusTimer){
                        clearInterval(this.orderStatusTimer);
                        this.orderStatusTimer = null;
                    }
                    this.orderStatusTimer = setInterval(() =>{
                        self.pollingOrderStatus();
                    },1000);
                }
            }).finally(()=>{
                this.loading = false;
            })
        },
        changePayTypeEvent(type){
            this.$store.dispatch('pay/setPayTokenDialog',{type});
            this.initOrder();
        },
        pollingOrderStatus(){
            let url = `${payApi.queryOrder}?orderNo=${this.order.orderNo}`;
            this.$ajax.get(url).then(res=>{
                if(res.status === 200){
                    let data = res.data;
                    if(data.orderStatus === 'paid'){
                        this.status = data.orderStatus;
                        clearInterval(this.orderStatusTimer);
                        this.orderStatusTimer = null;
                    }else if(data.orderStatus === 'failed'){
                        this.$message.success(this.$t('component.PayTokenDialog_method_pollingOrderStatus_message_1'));
                        this.initOrder();
                    }
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.pay-char-dialog{
    margin: 10px 0;
    min-height: 326px;
    .pay-type-content{
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        .item{
            position: relative;
            padding: 20px;
            width: 190px;
            margin-right: 20px;
            border: 2px solid transparent;
            box-sizing: border-box;
            border-radius: 12px;
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
            cursor: pointer;
            user-select: none;
            &:last-child{
                margin-right: 0;
            }
            &.active{
                border-color: #00D959;
            }
            .tag{
                border-radius: 0 12px 0 12px;
                background-color: #F56C6C;
                width: 48px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 500;
                font-size: 12px;
                color: #FFFFFF;
                position: absolute;
                top: -2px;
                right: -2px;
                &.erp {
                    background-color: #AA84DA;
                }
            }
        }
    }
    .pay-detail-content{
        width: 407px;
        height: 170px;
        padding: 0 26px;
        margin: 0 auto;
        background-color: #FFFFFF;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        .qrcode{
            width: 140px;
            height: 140px;
        }
    }
}
.pay-pro-success{
    margin-top: 20px;
    margin-bottom: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    i {
        font-size: 44px;
        color: #00B670;
    }
    img {
        margin-top: 40px;
        width: 140px;
    }

}
</style>
